export default {
	apikey: "c6b66ed"
}
